export default __webpack_public_path__ + "static/media/ic_notesx.4d2f6532.svg";